import { render, staticRenderFns } from "./CardAlarmPopover.vue?vue&type=template&id=be8d8f12&scoped=true&"
import script from "./CardAlarmPopover.vue?vue&type=script&lang=js&"
export * from "./CardAlarmPopover.vue?vue&type=script&lang=js&"
import style0 from "./CardAlarmPopover.vue?vue&type=style&index=0&id=be8d8f12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8d8f12",
  null
  
)

export default component.exports